import { DEFAULT_SCOPES, type OAuthConfig } from "@app/storage";
import { detectPlatform } from "../platform.js";

/** Public OAuth client ids, baked in at build time (not secrets — PKCE protects
 *  the public-client flow). Web uses the web client; Capacitor (Android) uses a
 *  native client whose reversed form is the custom-scheme redirect. */
const WEB_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "";
const NATIVE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID_NATIVE ?? "";

/** The client id to use on the current platform (native on Capacitor, else web;
 *  native falls back to the web id when unset so dev keeps working). */
export function activeGoogleClientId(): string {
  if (detectPlatform() === "capacitor") return NATIVE_CLIENT_ID || WEB_CLIENT_ID;
  return WEB_CLIENT_ID;
}

/** Whether Google Calendar sync can be offered on this platform. */
export const googleConfigured = (): boolean => Boolean(activeGoogleClientId());

export function googleOAuthConfig(): OAuthConfig {
  return { clientId: activeGoogleClientId(), scopes: DEFAULT_SCOPES };
}

/** Identity-only sign-in: no Calendar scopes, no offline refresh token. Yields an
 *  OIDC ID token we hand to our server to mint OUR account tokens. Distinct from
 *  {@link googleOAuthConfig} — connecting Calendar is a separate, heavier consent. */
export function googleIdentityOAuthConfig(): OAuthConfig {
  return { clientId: activeGoogleClientId(), scopes: ["openid", "email", "profile"] };
}
